import axios from 'axios'
import { Platform, Dimensions } from 'react-native'
import { actionTypes, ACTION_NAMES } from '@adalo/constants'
import { getPayload } from './jwt'
import { unsafeGetToken } from '../ducks/auth'

const PRODUCTION_URL = 'https://analytics.adalo.com'

const getAnalyticsURL = () => {
  let analyticsURL =
    process.env.NODE_ENV === 'production'
      ? PRODUCTION_URL
      : process.env.REACT_APP_ANALYTICS_URL

  return analyticsURL
}

const isPWA = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone ||
  document.referrer.includes('android-app://')

window.isPWA = isPWA

export const logEvent = (event, app, component, metadata = {}, opts = {}) => {
  window.setTimeout(async () => {
    let url = getAnalyticsURL()

    let appId = app.id
    let token = getPayload(unsafeGetToken(null, app))

    if (!url || opts.disableAnalytics) {
      return
    }

    let { userId } = token || {}
    let additional = { Screen: component && component.name }

    if (event === actionTypes.NAVIGATE) {
      let { target } = metadata
      let screen = app.components[target]

      if (screen) {
        additional['Target Screen'] = screen.name
      } else {
        event = 'Link Back'
      }
    }

    if (opts.appVersion) {
      additional.appVersion = opts.appVersion
    }

    let eventName = ACTION_NAMES[event] || event

    let platform = Platform.OS

    if (platform === 'web') {
      if (isPWA()) {
        platform = 'web-pwa'
      }
    }

    const windowWidth = Dimensions.get('window').width
    const windowHeight = Dimensions.get('window').height
    const windowSize = { width: windowWidth, height: windowHeight }
    let device

    if (windowWidth <= 767) {
      device = 'mobile'
    } else if (windowWidth > 767 && windowWidth <= 1024) {
      device = 'tablet'
    } else {
      device = 'desktop'
    }

    await axios.post(`${url}/events`, {
      appId,
      userId,
      event: eventName,
      metadata: { ...additional, platform, windowSize, device },
    })

    await axios.post(`${url}/events`, {
      appId,
      userId,
      event: eventName,
      metadata: { ...additional, platform },
    })
  }, 0)
}

export const identifyUser = async (appId, user) => {
  let url = getAnalyticsURL()

  if (!url) {
    return
  }

  let { id, name, email } = user

  await axios.post(`${url}/users`, {
    appId,
    name,
    email,
    userId: id,
  })
}
